module.exports = __webpack_public_path__ + "static/media/gavi.b28612ea.jpg";